<script>
    import R, {LOADER} from "../lib/requests";
    import {POINTS_ACTION} from "../lib/constants.js";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import {formatDate, memberName} from "../lib/lib.js";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let memberId = null;
    export let totalPoints = null;

    let list = null;

    export const initialize = () => {
        if (memberId && memberId > 0 && !list) {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            list = result;
            list.map(item => {
                if (item.action_id == POINTS_ACTION.ADD) {
                    item.action = "Added";
                } else if (item.action_id == POINTS_ACTION.REMOVE) {
                    item.action = "Removed";
                } else if (item.action_id == POINTS_ACTION.TRANSFER) {
                    if (item.points < 0) {
                        item.action = 'Transfer to';
                        // item.points = ~~item.points * -1;
                    } else {
                        item.action = 'Transfer from';
                    }
                } else if (item.action_id == POINTS_ACTION.SIGNUP) {
                    item.action = 'Sign up';
                } else if (item.action_id == POINTS_ACTION.CHECKIN) {
                    item.action = 'Check in';
                }
            });
        }

        const onFailure = err => {
        };

        R.handle(R.member.points, memberId, onSuccess, onFailure, LOADER.POPUP);
    }

    const onDelete = item => {
        Alert.delete("Delete points entry", "Are you sure you want to delete this points entry?\nThis will affect member points!", () => deletePoints(item.id));
    }

    const deletePoints = id => {
        const onSuccess = result => {
            list = list.filter(x => x.id != id);
        }

        const onFailure = err => {
        };

        R.handle(R.member.deletePoints, id, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

{#if totalPoints}
    <div class="mb-3">
        Member points: <b>{ totalPoints }</b>
    </div>
{/if}
{#if list}
    {#if list.length}
        <table class="table table-list">
            <thead>
            <tr>
                <th>DATE</th>
                <th>POINTS</th>
                <th>ACTION</th>
                <th>USER</th>
                {#if user.isAdmin()}
                    <th></th>
                {/if}
            </tr>
            </thead>
            <tbody>
            {#each list as item}
                <tr>
                    <td class="datetime-column text-gray">{ formatDate(item.created_at, 'd-m-y H:i') }</td>
                    <td class="points-column">{ item.points }</td>
                    <td class="text-gray">
                        { item.action }
                        {#if item.member}
                            <b>{ memberName(item.member) }</b>
                        {:else if item.hotel}
                            <b>"{ item.hotel.name }"</b>
                        {/if}
                    </td>
                    <td class="text-gray">
                        {#if item.user}
                            { item.user.name }
                        {/if}
                    </td>
                    {#if user.isAdmin()}
                        <td class="button-column">
                            <button class="btn" title="delete points entry" on:click={ () => onDelete(item) }>
                                <AppIcon icon="trash" size="16"/>
                            </button>
                        </td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        Member has no points!
    {/if}
{/if}

<style>
    .points-column {
        width: 80px;
        text-align: right;
    }
</style>